import { Box, Button, Typography } from '@material-ui/core';
import {
  Assessment,
  PlayCircleFilled as PlayCircleFilledIcon,
} from '@material-ui/icons';

import type { IqeProject } from '../../interfaces/ui';

interface TestExecutionEmptyStateProps {
  project: IqeProject;
  isToolAdmin: boolean;
  onGenerateTests: (projectId: string) => void;
  showAction?: boolean;
}

export default function TestExecutionEmptyState({
  project,
  isToolAdmin,
  onGenerateTests,
  showAction = true,
}: TestExecutionEmptyStateProps) {
  const hasPreviousRuns = (project.runs?.length || 0) > 0;
  const canRetryGeneration =
    project.status === 'GENERATE_FAILED' && !hasPreviousRuns;
  const isDisabled =
    !isToolAdmin || !(project.status === 'SUCCESSFUL' || canRetryGeneration);
  return (
    <Box
      component="section"
      className="pd-empty-state"
      aria-labelledby="details-empty-title"
    >
      <Box className="pd-empty-icon-box">
        <Assessment />
      </Box>
      <Typography id="details-empty-title" className="pd-empty-title">
        No test executions available yet
      </Typography>
      <Typography className="pd-empty-subtitle">
        Generate and execute your first test suite to create test cases,
        validate workflows, and start building execution history.
      </Typography>
      {showAction && (
        <Button
          variant="contained"
          color="primary"
          className="pd-cta-btn"
          disabled={isDisabled}
          aria-label="Generate and execute tests"
          startIcon={<PlayCircleFilledIcon />}
          onClick={() => onGenerateTests(project.id)}
        >
          {canRetryGeneration ? 'Retry Generation' : 'Generate & Execute Tests'}
        </Button>
      )}
    </Box>
  );
}